<template>
    <div class="animated fadeIn">
        <DynamicForm
                v-model="dataId"
                ref="dynamicForm"
                getRoot="/district"
                saveRoot="/district"
                @onTrashClick="onTrashClick"
                :formStructure="dataFormStructures.district">
        </DynamicForm>
        <ModalTrash
                ref="trash"
                root="/district"
                @onTrashSuccess="onTrashSuccess"
                :caption="Core.Definition.getDefinition('Suppression de la région')"
                :message="Core.Definition.getDefinition('Êtes-vous sûr de vouloir supprimer cette région?')"></ModalTrash>
    </div>
</template>

<script>
    import DynamicForm from '../../components/DynamicForm'
    import ModalTrash from '../../components/ModalTrash'
    export default {
        name: 'District',
        components: {
            DynamicForm,
            ModalTrash
        },
        mounted() {
        },
        data: function () {
            return {
                dataCapsGroups: [],
                Core: window.Core,
                dataId: '',
                dataFormStructures: {
                    district: {
                        rows: [
                            {
                                cols: [
                                    {
                                        cards: [
                                            {
                                                caption: Core.Definition.getDefinition('Région'),
                                                rows: [
                                                    {
                                                        cols: [
                                                            {
                                                                fields: [
                                                                    {
                                                                        id: 'title'
                                                                    }
                                                                ]
                                                            },
                                                            {
                                                                fields: [
                                                                    {
                                                                        id: 'color'
                                                                    }
                                                                ]
                                                            }
                                                        ]
                                                    }
                                                ]
                                            }
                                        ]
                                    }
                                ]
                            }
                        ],
                        fields: [
                            {
                                id: 'title',
                                type: 'text',
                                label: Core.Definition.getDefinition('Titre'),
                                value: '',
                                sortable: true
                            },
                            {
                                id: 'color',
                                type: 'color',
                                mode: 'sketch',
                                label: Core.Definition.getDefinition('Couleur'),
                                value: {}
                            }
                        ]
                    }
                }
            }
        },
        methods: {
            onTrashClick(id) {
                this.$refs.trash.open(id)
            },
            onTrashSuccess() {
                this.$router.push('/lieu/regions')
            }
        }
    }
</script>
